import { defineMessages } from "react-intl";

export const dashboardMessages = defineMessages({
  "dashboard.header": {
    id: "dashboard.header",
    defaultMessage: "Hello, {user}",
    description: "First text user sees after login",
  },
  "dashboard.perex": {
    id: "dashboard.perex",
    defaultMessage:
      "Track your progress from development areas to actionable goals, and unlock your leadership potential step by step.",
  },
  "dashboard.section-1.heading": {
    id: "dashboard.section-1.heading",
    defaultMessage: "Who am I",
  },
  "dashboard.upcoming.heading": {
    id: "dashboard.upcoming.heading",
    defaultMessage: "Upcoming sessions",
  },
  "dashboard.actions.empty.title": {
    id: "dashboard.actions.empty.title",
    defaultMessage: "No actions",
  },
  "dashboard.actions.empty.perex": {
    id: "dashboard.actions.empty.perex",
    defaultMessage: "Go through a session to set action points for your goal",
  },
  "dashboard.actions.empty.action": {
    id: "dashboard.actions.empty.action",
    defaultMessage: "Start private session",
  },
  "dashboard.upcoming.empty.title": {
    id: "dashboard.upcoming.empty.title",
    defaultMessage: "No upcoming sessions",
  },
  "dashboard.upcoming.empty.perex": {
    id: "dashboard.upcoming.empty.perex",
    defaultMessage: "Sessions with a coach will appear here",
  },
  "dashboard.upcoming.empty.perex-coach": {
    id: "dashboard.upcoming.empty.perex-coach",
    defaultMessage: "Sessions with a client will appear here",
  },
  "dashboard.learn.heading": {
    id: "dashboard.learn.heading",
    defaultMessage: "Learn",
  },
  "dashboard.upcoming.empty.action.select-coach": {
    id: "dashboard.upcoming.empty.action.select-coach",
    defaultMessage: "Select coach",
  },
  "dashboard.upcoming.empty.action.schedule-session": {
    id: "dashboard.upcoming.empty.action.schedule-session",
    defaultMessage: "Schedule session",
  },
  "dashboard.section-1.perex": {
    id: "dashboard.section-1.perex",
    defaultMessage:
      "Before you set where you are heading it's good to know from where you started.",
  },
  "dashboard.cards.strengths.title.filled": {
    id: "dashboard.cards.strengths.title.filled",
    defaultMessage: "My talents",
  },
  "dashboard.cards.strengths.title.empty": {
    id: "dashboard.cards.strengths.title.empty",
    defaultMessage: "Find my talents",
  },
  "dashboard.cards.strengths.perex": {
    id: "dashboard.cards.strengths.perex",
    defaultMessage:
      "Understand your top talents to focus on what you excel at.",
  },
  "dashboard.cards.values.title.filled": {
    id: "dashboard.cards.values.title.filled",
    defaultMessage: "My values",
  },
  "dashboard.cards.values.title.empty": {
    id: "dashboard.cards.values.title.empty",
    defaultMessage: "Set my values",
  },
  "dashboard.cards.values.perex": {
    id: "dashboard.cards.values.perex",
    defaultMessage: "Your values are a central part of who you are.",
  },
  "dashboard.cards.notes.title": {
    id: "dashboard.cards.notes.title",
    defaultMessage: "My notes",
  },
  "dashboard.cards.notes.placeholder.empty": {
    id: "dashboard.cards.notes.placeholder.empty",
    defaultMessage: "Type something",
  },
  "dashboard.cards.feedback.title": {
    id: "dashboard.cards.feedback.title",
    defaultMessage: "Get feedback",
  },
  "dashboard.cards.sessions.title.filled": {
    id: "dashboard.cards.sessions.title.filled",
    defaultMessage: "My areas of development",
  },
  "dashboard.cards.ai.empty.title": {
    id: "dashboard.cards.ai.empty.title",
    defaultMessage: "Insights and daily tips",
  },
  "dashboard.cards.ai.empty.perex": {
    id: "dashboard.cards.ai.empty.perex",
    defaultMessage:
      "Unlock personalized insights through the combination of your Talents and Values.",
  },
  "dashboard.cards.ai.empty.steps.strengths.title": {
    id: "dashboard.cards.ai.empty.steps.strengths.title",
    defaultMessage: "Assess your talents",
  },
  "dashboard.cards.ai.empty.steps.strengths.button": {
    id: "dashboard.cards.ai.empty.steps.strengths.button",
    defaultMessage: "Find my talents",
  },
  "dashboard.cards.ai.empty.steps.values.title": {
    id: "dashboard.cards.ai.empty.steps.values.title",
    defaultMessage: "Define your values",
  },
  "dashboard.cards.ai.empty.steps.values.button": {
    id: "dashboard.cards.ai.empty.steps.values.button",
    defaultMessage: "Set my values",
  },
  "dashboard.cards.ai.empty.steps.explore.title": {
    id: "dashboard.cards.ai.empty.steps.explore.title",
    defaultMessage: "Explore uniqueness & get growth tips",
  },
  "dashboard.cards.ai.insights.title": {
    id: "dashboard.cards.ai.insights.title",
    defaultMessage: "Insights",
  },
  "dashboard.cards.ai.insights.perex": {
    id: "dashboard.cards.ai.insights.perex",
    defaultMessage:
      "Unlock personalized insights through the combination of your Talents and Values.",
  },
  "dashboard.cards.ai.insights.leadership-style.heading": {
    id: "dashboard.cards.ai.insights.leadership-style.heading",
    defaultMessage: "What is my ideal leadership style?",
  },
  "dashboard.cards.ai.insights.leadership-style.desc": {
    id: "dashboard.cards.ai.insights.leadership-style.desc",
    defaultMessage:
      "Discover your ideal way to lead, based on your unique talents and values.",
  },
  "dashboard.cards.ai.insights.leader-persona.heading": {
    id: "dashboard.cards.ai.insights.leader-persona.heading",
    defaultMessage: "Who should inspire me?",
  },
  "dashboard.cards.ai.insights.leader-persona.desc": {
    id: "dashboard.cards.ai.insights.leader-persona.desc",
    defaultMessage:
      "Find out which world leaders share your values and talents",
  },
  "dashboard.cards.ai.insights.animal-spirit.heading": {
    id: "dashboard.cards.ai.insights.animal-spirit.heading",
    defaultMessage: "My spirit animal revealed",
  },
  "dashboard.cards.ai.insights.animal-spirit.desc": {
    id: "dashboard.cards.ai.insights.animal-spirit.desc",
    defaultMessage: "Find the animal that represents your unique strengths",
  },
  "dashboard.cards.ai.tips.title": {
    id: "dashboard.cards.ai.tips.title",
    defaultMessage: "Daily tips",
  },
  "dashboard.cards.ai.tips.leadership.title": {
    id: "dashboard.cards.ai.tips.leadership.title",
    defaultMessage:
      "Leadership Tip - Harness your unique mix of talents and values with actionable tips to enhance your leadership journey every day.",
  },
  "dashboard.cards.ai.tips.personal-growth.title": {
    id: "dashboard.cards.ai.tips.personal-growth.title",
    defaultMessage: "Action Blueprint",
  },
  "dashboard.section-2.heading": {
    id: "dashboard.section-2.heading",
    defaultMessage: "Who to become",
  },
  "dashboard.section-2.perex": {
    id: "dashboard.section-2.perex",
    defaultMessage: "Become a better leader and here is how you get there.",
  },
  "dashboard.my-leader-profile": {
    id: "dashboard.my-leader-profile",
    defaultMessage: "My leader profile",
  },
  "dashboard.unlock-steps.perex": {
    id: "dashboard.unlock-steps.perex",
    defaultMessage:
      "Once you pass the assessments, your talents and values will appear here",
  },
  "dashboard.rightmenu.title": {
    id: "dashboard.rightmenu.title",
    defaultMessage: "My leadership journey",
  },
  "dashboard.rightmenu.today": {
    id: "dashboard.rightmenu.today",
    defaultMessage: "Today, {date}",
  },
  "dashboard.rightmenu.upcoming.title.empty": {
    id: "dashboard.rightmenu.upcoming.title.empty",
    defaultMessage: "No upcoming sessions",
  },
  "dashboard.rightmenu.upcoming.perex.empty": {
    id: "dashboard.rightmenu.upcoming.perex.empty",
    defaultMessage: "Once you set a goal, actions will apear here",
  },
  "dashboard.rightmenu.upcoming.start": {
    id: "dashboard.rightmenu.upcoming.start",
    defaultMessage: "Start session",
  },
  "dashboard.rightmenu.actions.heading": {
    id: "dashboard.rightmenu.actions.heading",
    defaultMessage: "Short-term goals",
  },
  "dashboard.rightmenu.actions.title.empty": {
    id: "dashboard.rightmenu.actions.title.empty",
    defaultMessage: "No short-term goals set",
  },
  "dashboard.rightmenu.actions.perex.empty": {
    id: "dashboard.rightmenu.actions.perex.empty",
    defaultMessage: "Once you set a goal, actions will apear here",
  },
  "dashboard.rightmenu.actions.set-area": {
    id: "dashboard.rightmenu.actions.set-area",
    defaultMessage: "Define your development path",
  },
  "dashboard.ai.help-header": {
    id: "dashboard.ai.help-header",
    defaultMessage: "What's bothering you right now?",
  },
  "dashboard.ai.help.second-header": {
    id: "dashboard.ai.help.second-header",
    defaultMessage:
      "Share your leadership challenge, workplace struggle, or anything             holding you back... This is anonymous and safe.",
  },
  "dashboard.ai.help.placeholder": {
    id: "dashboard.ai.help.placeholder",
    defaultMessage:
      "Share your leadership challenge, workplace struggle, or anything holding you back...",
  },
  "dashboard.ai.help.suggestion": {
    id: "dashboard.ai.help.suggestion",
    defaultMessage: "Suggestion",
  },
  "dashboard.ai.help.checkbox": {
    id: "dashboard.ai.help.checkbox",
    defaultMessage: "Share anonymously with community for peer suggestions",
  },
  "dashboard.ai.help.header.one": {
    id: "dashboard.ai.help.header.one",
    defaultMessage: "AI-Curated Videos",
  },
  "dashboard.ai.help.text.one": {
    id: "dashboard.ai.help.text.one",
    defaultMessage:
      "Get personalized video recommendations based on your specific leadership challenges",
  },
  "dashboard.ai.help.header.two": {
    id: "dashboard.ai.help.header.two",
    defaultMessage: "Expert Articles",
  },
  "dashboard.ai.help.text.two": {
    id: "dashboard.ai.help.text.two",
    defaultMessage:
      "Access relevant articles and insights tailored to your situation and growth needs",
  },
  "dashboard.ai.help.header.three": {
    id: "dashboard.ai.help.header.three",
    defaultMessage: "Actionable Steps",
  },
  "dashboard.ai.help.text.three": {
    id: "dashboard.ai.help.text.three",
    defaultMessage:
      "Receive specific, actionable recommendations you can implement immediately",
  },
});
